<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <vs-table
        ref="table"
        pagination
        :max-items="itemsPerPage"
        search
        :total="total"
        :sst="true"
        :data="invoices"
        @search="handleSearch"
        @sort="handleSort"
        @change-page="getInvoices">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center">
            <h1 class="mr-2">Facturen</h1>

            <!-- ADD NEW -->
            <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="confirmSentInvoices">
              <span class="ml-2 text-base text-primary">Sent Last Weeks Invoices</span>
            </div>
        </div>
        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ invoices.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : invoices.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=50">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=75">
              <span>75</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=100">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="id">Nummer</vs-th>
        <vs-th sort-key="name">Bedrijf</vs-th>
        <vs-th sort-key="price">Prijs</vs-th>
        <vs-th sort-key="vat">BTW</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template>
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in invoices" @click.native="viewInvoice(tr.id, tr.company.slug)">

            <vs-td>
              <p class="order-id font-medium truncate">{{ tr.id }}</p>
            </vs-td>

            <vs-td>
              <p class="order-name font-medium truncate">{{ tr.company.name }}</p>
            </vs-td>

            <vs-td>
              <p class="order-description">€ {{ tr.due_amount }}</p>
            </vs-td>

            <vs-td>
              <p class="order-vat">{{ tr.vat }}</p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon icon="DownloadIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="viewInvoice(tr.id, tr.company.slug)" />
            </vs-td>

          </vs-tr>
        </tbody>

      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  created () {},
  mounted () {
    this.isMounted = true
    this.getInvoices();
  },
  data () {
    return {
      selected: [],
      invoices: [],
      itemsPerPage: 25,
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {},
      total: 0,
      popupActive: false
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.invoices.length
    },
    staffRoute () {
      if(this.$route.meta.staff) {
        if(localStorage.getItem('stafftoken') !== null) {
          return true
        }
      } else {
        if(localStorage.getItem('stafftoken') !== null) {
          return true
        }
        return false
      }
    },
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      if(to.params.slug !== null) {
        this.getInvoices();
      }
    },
  },
  methods: {
    confirmSentInvoices() {
      if(confirm('Weet u zeker dat u alle facturen van deze week wilt versturen?')) {
        this.$vs.loading();
        this.sentLastWeeksInvoices();
      }
    },
    sentLastWeeksInvoices () {
      this.$http.get("/v1/invoices/sent-last-week")
        .then((response) => {
          console.log(response.data);
          this.$vs.loading.close();
        }).catch((error) => {
          console.log(error.data);
        });
    },
    getInvoices (e) {
      var url = 'https://staffapi.hebtrek.nl/v1/invoices';
      if(e !== null && e !== undefined) {
        url += '?page=' + e
      }
      this.$http.get(url, {
        headers: {
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('stafftoken'))
        }
      }).then((response) => {
        this.invoices = response.data.data
        this.total = response.data.total;
        this.itemsPerPage = response.data.per_page;
      }).catch((error) => {
        this.$util.logError(error, this.$vs);
      })
    },
    handleSearch(search) {
        var url = 'https://staffapi.hebtrek.nl/v1/invoices/search?page=' + this.currentPage;
        this.$http.get(url, {
            headers: {
                Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('stafftoken'))
            },
            params: {
                regex: search.toString()
            }
        }).then((response) => {
            this.invoices = response.data.data;
            this.total = response.data.total;
            this.itemsPerPage = response.data.per_page;
        }).catch((error) => {
          this.$util.logError(error, this.$vs);
        });
    },
    handleSort(sort) {
        console.log(sort);
    },
    viewInvoice (id, slug) {
      var url = 'https://staffapi.hebtrek.nl/v1/company/'+ slug +'/invoice'
     this.$http.get(url, {
        headers: {
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('stafftoken'))
        },
        params: {
          'id': id
        }
      }).then((response) => {
        window.open(response.data.link);
        console.log(response.data.link);
      }).catch((error) => {
       this.$util.logError(error, this.$vs);
      })
    },
    getProductStatusColor (status) {
        if (status === 'on_hold')   return 'warning'
        if (status === 'delivered') return 'success'
        if (status === 'canceled')  return 'danger'
        return 'primary'
    },
    getPopularityColor (num) {
        if (num > 90)  return 'success'
        if (num > 70)  return 'primary'
        if (num >= 50) return 'warning'
        if (num < 50)  return 'danger'
        return 'primary'
    },
    toggleDataSidebar (val = false) {
        this.addNewDataSidebar = val
    },
    getStatus(status) {
        if(status == 0) {
            return 'inactief';
        }
        if(status == 1) {
            return 'open';
        }
        if(status == 2) {
            return 'gesloten';
        }
        if(status == 3) {
            return 'Tijdelijk gesloten';
        }
        if(status == 4) {
            return 'Binnenkort geopend';
        }
    }
  }
}
</script>

<style lang="scss">
  #data-list-thumb-view {
    h1 {
      padding-bottom: 15px;
      margin-left: 20px;
    }
  .vs-con-table {

    .order-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;


      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 10px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
            &.img-container {
              width: 1rem;
              background: #fff;

              span {
                display: flex;
                justify-content: flex-start;
              }

              .order-img {
                max-height: 100px;
                max-width: 100px;
              }
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
